"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  "properties": {
    "group": "editor",
    "type": "features",
    "toolbar": [{ "id": "tools.text.none", "label": "Text", "visible": true }, {
      "id": "tools.checkmark.x",
      "label": "Cross",
      "visible": true
    }, { "id": "tools.checkmark.v", "label": "Check", "visible": true }, {
      "id": "tools.checkmark.o",
      "label": "Circle",
      "visible": true
    }, { "id": "tools.signature.*", "label": "Sign", "visible": false }, {
      "id": "tools.text.date",
      "label": "Date",
      "visible": true
    }, { "id": "tools.image.none", "label": "Image", "visible": false }, {
      "id": "tools.erase.none",
      "label": "Erase",
      "visible": true
    }, { "id": "tools.highlight.none", "label": "Highlight", "visible": true }, {
      "id": "tools.blackout.none",
      "label": "Blackout",
      "visible": true
    }, { "id": "tools.textbox.none", "label": "Text Box", "visible": true }, {
      "id": "tools.arrow.none",
      "label": "Arrow",
      "visible": true
    }, { "id": "tools.line.none", "label": "Line", "visible": true }, {
      "id": "tools.pen.none",
      "label": "Draw",
      "visible": true
    }, { "id": "tools.sticky.none", "label": "Sticky", "visible": true }],
    "extrasbar": [{ "id": "tools.template", "label": "Constructor", "visible": true }, {
      "id": "versions",
      "label": "Versions",
      "visible": false
    }, { "id": "tools.attributes", "label": "Watermark", "visible": true }],
    "misc": [{ "id": "tools.pages", "label": "Rearrange", "visible": false }, {
      "id": "tools.comments",
      "label": "Comments",
      "visible": false
    }, { "id": "common.thumbnails", "label": "Thumbnails", "visible": true }, {
      "id": "common.help",
      "label": "Help",
      "visible": true
    }, { "id": "common.feedback", "label": "Feedback", "visible": false }, {
      "id": "signature_wizard.options",
      "label": "",
      "type": true,
      "draw": true,
      "upload": true,
      "capture": true,
      "qr": true,
      "sms": true,
      "email": true,
      "notarize": true,
      "notarizeLocation": false,
      "visible": false
    }, { "id": "common.search", "label": "Search", "visible": false }, {
      "id": "tools.fakePdfEdit",
      "label": "",
      "visible": false
    }],
    "modebar": [{
      "id": "mode.main",
      "label": "Edit",
      "visible": false,
      "selected": false
    }, {
      "id": "mode.constructor",
      "label": "Add Fields",
      "visible": false,
      "selected": false
    }, { "id": "mode.preview", "label": "Preview", "visible": false, "selected": false }],
    "constructor": [{ "id": "control.breadcrumbs", "visible": true, "label": null }, {
      "id": "button.preview",
      "label": "Preview",
      "visible": true
    }, { "id": "button.cancel", "label": "Cancel", "visible": true }, {
      "id": "button.save",
      "label": "SAVE",
      "visible": true
    }],
    "preview": [{ "id": "control.breadcrumbs", "visible": true, "label": null }, {
      "id": "button.exit_preview",
      "label": "Preview",
      "visible": true
    }],
    "planPermissions": [{ "id": "tools.text.none", "allowed": true }, {
      "id": "tools.checkmark.x",
      "allowed": true
    }, { "id": "tools.checkmark.v", "allowed": true }, {
      "id": "tools.checkmark.o",
      "allowed": true
    }, { "id": "tools.text.date", "allowed": true }, { "id": "tools.erase", "allowed": true }, {
      "id": "tools.blackout",
      "allowed": true
    }, { "id": "tools.highlight", "allowed": true }, { "id": "tools.textbox", "allowed": true }, {
      "id": "tools.arrow",
      "allowed": true
    }, { "id": "tools.line", "allowed": true }, { "id": "tools.pen", "allowed": true }, {
      "id": "tools.sticky",
      "allowed": true
    }, { "id": "signatures.add", "allowed": false, "freeLimit": 3 }, {
      "id": "images.add",
      "allowed": false
    }, { "id": "versions.apply", "allowed": true }, {
      "id": "tools.*.signature.stamp",
      "allowed": true
    }, { "id": "tools.pages", "allowed": true }, {
      "id": "tools.attributes.*",
      "allowed": true
    }, { "id": "tools.template", "allowed": true }],
    "logo": {
      "urls": {
        "large": "https://static_dev81.pdffillers.com/img/header/logo-pdffiller.svg",
        "small": "https://static_dev81.pdffillers.com/img/header/logo-pdffiller-small.svg"
      }, "visible": true
    },
    "doneButton": {
      "main": {
        "id": "done.choice",
        "label": "DONE",
        "location": "https://dev3.pdffiller.com/en/forms.htm?projectId=1569540027&blank=1"
      },
      "list": [],
      "visible": true
    },
    "enabled": true
  }, "actionTime": 1581519580552
};